/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Select } from "antd";
import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import Fireworks from "../ResultsAndEffects/fireworks";

export default function Dice({ props }) {
  const [disableSelect1, setDisableSelect1] = React.useState(true); //disalbe select 1
  const [disableSelect2, setDisableSelect2] = React.useState(true); //disalbe select 2
  const turn = React.useRef(0);
  const clickButton = React.useRef(false); // click button xác nhận
  const buttonDice = React.useRef(null); // button đỗ xúc sắc
  const [submitButton1, setSubmitButton1] = React.useState(true); //button xác nhận1
  const [submitButton2, setSubmitButton2] = React.useState(true); //button xác nhận2
  const [erroMessage, setErroMessage] = React.useState();
  const [endGame, setEndGame] = React.useState();
  const [openModal, setOpenModal] = React.useState(false);

  // ==================Team1==========================

  const borderTeam1Position = props[0].borderTeam1Position || [];
  const t1DefaultPosition = props[0].team1DefaultPosition;
  const team1AnswersArray = props[0].team1Answers || [];
  const team1Step = React.useRef(0);
  const [team1Answer, setTeam1Answer] = React.useState(0);
  const team1CorrectAnswer = React.useRef(false);
  const borderTeam1 = React.useRef(null);
  // ==================End Team1==========================

  // ==================Team2==========================
  const borderTeam2Position = props[0].borderTeam2Position || [];
  const t2DefaultPosition = props[0].team2DefaultPosition;
  const team2AnswersArray = props[0].team2Answers || [];
  const [team2Answer, setTeam2Answer] = React.useState(0);
  const team2CorrectAnswer = React.useRef(false);
  const borderTeam2 = React.useRef(null);
  const team2Step = React.useRef(0);

  // ==================End Team2==========================

  React.useEffect(() => {
    const button = document.getElementById("button-xuc-sac");
    buttonDice.current = button;
    borderTeam1.current = document.getElementById("border-team1");
    borderTeam2.current = document.getElementById("border-team2");
    button.addEventListener("click", () => {
      rollDice(button);
    });

    return () => {
      button.removeEventListener("click", () => {
        rollDice(button);
      });
    };
  }, []);

  const sleep = (second) => {
    return new Promise((resolve) => setTimeout(resolve, second));
  };

  const rollDice = async (button) => {
    turn.current += 1;
    clickButton.current = false;
    const dice = document.getElementById("dice-image");
    dice.classList.add("dice-shake");
    button.disabled = true;
    button.style.cursor = "no-drop";

    await sleep(1000);
    dice.classList.remove("dice-shake");

    await sleep(1000);
    let random = Math.floor(Math.random() * 6);

    dice.setAttribute("src", `/img/FriendsPlus/page29/E3/dice-${random}.png`);

    // disable hoặc enable các butoon theo lượt
    if ((turn.current - 1) % 2 === 0) {
      setDisableSelect1(false);
      setSubmitButton1(false);
      setSubmitButton2(true);
    } else {
      setDisableSelect2(false);
      setSubmitButton1(true);
      setSubmitButton2(false);
    }
    setTeam1Answer(0);
    setTeam2Answer(0);
    await changePositionBorder(random);
  };

  // kiểm tra lượt chẵn,lẻ
  const checkTurn = async (button) => {
    if (clickButton.current) {
      if (turn.current % 2 === 0) {
        buttonDice.current.innerHTML = "Đội Xanh";
      } else {
        buttonDice.current.innerHTML = "Đội Vàng";
      }
      buttonDice.current.disabled = false;
      buttonDice.current.style.cursor = "pointer";
    }
  };

  const changePositionBorder = async (random) => {
    // đội xanh
    if ((turn.current - 1) % 2 === 0) {
      // random là số lẻ thì + 2 , số chẵn thì +1 (tính theo số của tên ảnh)
      if (random % 2 !== 0 && random !== 0) {
        team1Step.current += 2;
      } else {
        team1Step.current += 1;
      }

      if (team1Step.current >= 10) team1Step.current = 10;

      // di chuyển boder
      for (let i = team1Step.current - 2; i < team1Step.current; i++) {
        if (i < 0) i = 0;
        await sleep(1000);

        borderTeam1.current.style.top = borderTeam1Position[i].top;
        borderTeam1.current.style.left = borderTeam1Position[i].left;
      }
    }
    // đội vàng
    else {
      // random là số lẻ thì + 2 , số chẵn thì +1 (tính theo số của tên ảnh)

      if (random % 2 !== 0 && random !== 0) {
        team2Step.current += 2;
      } else {
        team2Step.current += 1;
      }
      if (team2Step.current >= 10) team2Step.current = 10;

      // di chuyển boder
      for (let i = team2Step.current - 2; i < team2Step.current; i++) {
        if (i < 0) i = 0;
        await sleep(1000);

        borderTeam2.current.style.top = borderTeam2Position[i].top;
        borderTeam2.current.style.left = borderTeam2Position[i].left;
      }
    }
  };

  const handleChange = (values) => {
    // đội xanh
    if ((turn.current - 1) % 2 === 0) {
      setTeam1Answer(values);
    }
    // đội vàng
    else if ((turn.current - 1) % 2 !== 0) {
      setTeam2Answer(values);
    }
  };

  const checkAnswers = async () => {
    if (
      (team1Answer === 0 && !submitButton1) ||
      (team2Answer === 0 && !submitButton2)
    ) {
      setErroMessage("chưa chọn đáp án");
      return;
    }
    setErroMessage(undefined);
    clickButton.current = true;
    await checkTurn();

    let t1AnswerIndex = team1Step.current - 1;
    let t2AnswerIndex = team2Step.current - 1;
    // đội xanh
    if ((turn.current - 1) % 2 === 0) {
      if (team1AnswersArray[t1AnswerIndex] === team1Answer) {
        team1CorrectAnswer.current = true;
      } else {
        team1CorrectAnswer.current = false;
      }

      setSubmitButton1(true);
      setDisableSelect1(true);
    }
    // đội vàng
    else {
      if (team2AnswersArray[t2AnswerIndex] === team2Answer) {
        team2CorrectAnswer.current = true;
      } else {
        team2CorrectAnswer.current = false;
      }
      setDisableSelect2(true);
      setSubmitButton2(true);
    }
    if (
      (team1Step.current >= 10 && team1CorrectAnswer.current === true) ||
      (team2Step.current >= 10 && team2CorrectAnswer.current === true)
    ) {
      endGameFn();
      return;
    }

    await goBack();
  };
  const goBack = async () => {
    // nếu trả lời sai thì lùi 1 ô
    // đội xanh
    if ((turn.current - 1) % 2 === 0 && !team1CorrectAnswer.current) {
      let step = team1Step.current - 2;
      team1Step.current = team1Step.current - 1;

      if (team1Step.current < 0) team1Step.current = 0;

      await sleep(1000);
      if (parseFloat(step) <= -1) {
        borderTeam1.current.style.top = t1DefaultPosition.top;
        borderTeam1.current.style.left = t1DefaultPosition.left;
        step = -1;
      } else if (step === 0) {
        borderTeam1.current.style.top = borderTeam1Position[0].top;
        borderTeam1.current.style.left = borderTeam1Position[0].left;
      } else {
        borderTeam1.current.style.top = borderTeam1Position[step].top;
        borderTeam1.current.style.left = borderTeam1Position[step].left;
      }
    }
    // đội vàng
    else {
      if ((turn.current - 1) % 2 !== 0 && !team2CorrectAnswer.current) {
        let step = team2Step.current - 2;
        team2Step.current = team2Step.current - 1;

        if (team2Step.current < 0) team2Step.current = 0;
        await sleep(1000);

        if (parseFloat(step) <= -1) {
          borderTeam2.current.style.top = t2DefaultPosition.top;
          borderTeam2.current.style.left = t2DefaultPosition.left;
          step = -1;
        } else if (step === 0) {
          borderTeam2.current.style.top = borderTeam2Position[0].top;
          borderTeam2.current.style.left = borderTeam2Position[0].left;
        } else {
          borderTeam2.current.style.top = borderTeam2Position[step].top;
          borderTeam2.current.style.left = borderTeam2Position[step].left;
        }
      }
    }
  };
  const endGameFn = () => {
    if (team1Step.current >= 10) {
      setEndGame("Đội Xanh");
      buttonDice.current.innerHTML = "Đội Xanh";
    } else if (team2Step.current >= 10) {
      setEndGame("Đội Vàng");
      buttonDice.current.innerHTML = "Đội Vàng";
    }
    buttonDice.current.disabled = true;
    buttonDice.current.style.cursor = "no-drop";

    setOpenModal(true);
    reset();
  };

  const reset = () => {
    let button = document.getElementById("button-choi-lai");
    let dice = document.getElementById("dice-image");
    button.style.display = "block";
    button.addEventListener("click", () => {
      team1Step.current = 0;
      team2Step.current = 0;
      turn.current = 0;
      borderTeam1.current.style.top = t1DefaultPosition.top;
      borderTeam1.current.style.left = t1DefaultPosition.left;
      borderTeam2.current.style.top = t2DefaultPosition.top;
      borderTeam2.current.style.left = t2DefaultPosition.left;
      setSubmitButton1(true);
      setSubmitButton2(true);
      setDisableSelect1(true);
      setDisableSelect2(true);
      buttonDice.current.disabled = false;
      buttonDice.current.style.cursor = "pointer";
      buttonDice.current.innerHTML = "Đội Xanh";
      button.style.display = "none";
      dice.setAttribute("src", `/img/FriendsPlus/page29/E3/dice-0.png`);
    });
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          columnGap: 5,
          position: "absolute",
          top: "297px",
          left: "550px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <p style={{ fontWeight: "bold", fontSize: 15 }}>
            Đội xanh chọn đáp án
          </p>
          <Select
            disabled={disableSelect1}
            style={{ width: 156, marginBottom: 10 }}
            value={team1Answer}
            placeholder="chọn đáp án"
            onChange={handleChange}
            options={[
              { value: 0, label: "chọn đáp án" },

              { value: 1, label: "góc nhọn" },
              { value: 2, label: "góc vuông" },
              { value: 3, label: "góc tù" },
              { value: 4, label: "góc bẹt" },
            ]}
          />
          {!submitButton1 && erroMessage && (
            <p style={{ color: "red" }}>{erroMessage}</p>
          )}

          <Button
            disabled={submitButton1}
            onClick={() => checkAnswers()}
            type="primary"
          >
            Xác nhận
          </Button>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 50,
          }}
        >
          <p style={{ fontWeight: "bold", fontSize: 15 }}>
            Đội vàng chọn đáp án
          </p>
          <Select
            disabled={disableSelect2}
            value={team2Answer}
            style={{ width: 156, marginBottom: 10 }}
            onChange={handleChange}
            options={[
              { value: 0, label: "chọn đáp án" },
              { value: 1, label: "góc nhọn" },
              { value: 2, label: "góc vuông" },
              { value: 3, label: "góc tù" },
              { value: 4, label: "góc bẹt" },
            ]}
          />
          {!submitButton2 && erroMessage && (
            <p style={{ color: "red" }}>{erroMessage}</p>
          )}

          <Button
            disabled={submitButton2}
            onClick={() => checkAnswers()}
            type="primary"
          >
            Xác nhận
          </Button>
        </div>
      </div>
      <Modal centered isOpen={openModal}>
        <ModalBody>
          <img
            src="/img/FriendsPlus/page29/E3/winnerCup.png"
            alt="images"
            width="100%"
          />
          <h2
            style={{
              position: "absolute",
              left: 194,
              top: 101,
              color: "rgb(232, 67, 147)",
            }}
          >
            CHÚC MỪNG
          </h2>

          <p
            style={{
              position: "absolute",
              left: 216,
              top: 134,
              color: "rgb(232, 67, 147)",
              fontWeight: "bold",
              fontSize: 20,
            }}
          >
            {endGame}
          </p>
          <Fireworks />
          <audio
            src="/Audios/page6/success-Sound.mp3"
            autoPlay={openModal}
            style={{ display: "none" }}
          ></audio>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setOpenModal(false)}>
            Đóng
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
